// extracted by mini-css-extract-plugin
module.exports = {"fontFamily":"\"Moderat\",-apple-system,blinkmacsystemfont,roboto,\"Droid Sans\",sans-serif","brandRed":"#f9423a","baseGray":"#a6a6a6","white":"#fff","black":"#000"};